import { render, staticRenderFns } from "./SubportionInfoSection.vue?vue&type=template&id=13b37bbe&"
import script from "./SubportionInfoSection.vue?vue&type=script&lang=js&"
export * from "./SubportionInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports